import React, { Component } from "react";
import Constants from "../constants";

import "../App.css";
import { ReactComponent as RightHandIcon } from "../img/right-icon.svg"
import { ReactComponent as LeftHandIcon } from "../img/left-icon.svg"
import liquefactionLegend from "../img/liquefaction-legend.png";


class MainPage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      sideBarOpen: true
    }
  }

  getSideBarOpen = () => {
    return this.state.sideBarOpen;
  }

  setSideBarOpen = (value) => {
    this.setState({
      sideBarOpen: value
    })
  }

  render() {
    const { getYearLevel } = this.props;
  return (
    <div className={this.getSideBarOpen() ? "column third": "column third closed"}>
      <button alt="hide panel" className="sidePanelButton" onClick={(() => {
        this.setSideBarOpen(!this.getSideBarOpen());
      })}>
    {this.getSideBarOpen() ?     <RightHandIcon /> : <LeftHandIcon />}

      </button>
      <div className={"thirdContent"}>

          {getYearLevel() === 0 ? (
      <div className="top-half border-blue padding-column">
      <h5>{Constants.liquefactionTitle}</h5>
      <p>{Constants.liquefactionText}</p>
        <h5>{Constants.liquefactionNoteTitle}</h5>
        <p>{Constants.liquefactionNoteText}</p>

                <h5>{Constants.uncertaintyTitle}</h5>
                <p>{Constants.uncertaintyText}</p>
      </div>
    ) : (
      <div className="top-half border-blue padding-column">
      <h5>{Constants.slr4Title}</h5>
      <p>{Constants.slr4Text}</p>
        <h5>{Constants.slr1Title}</h5>
        <p>{Constants.slr1Text}</p>
        <h5>{Constants.slr2Title}</h5>
        <p>{Constants.slr2Text}</p>

        <h5>{Constants.notesTitle}</h5>
        <p>{Constants.notesText}</p>

      </div>)}


      {getYearLevel() === 0 ?
    (    <div className="bottom-half border-blue padding-column">
      <h5>{Constants.legendTitle2}</h5>
      <p>{Constants.legendText2}</p>
      <img src={liquefactionLegend} alt="liquefaction legend" className={"legendImage"}/>
      {/*
      <ul className="bottom-list">
        {Constants.legendData2.map((item, index) => {
          return (
            <li key={`legend2  -- ${index}`}>
              <svg height="30" width="30">
                <circle cx="15" cy="15" r="10" fill={item.color} />
              </svg>
              {item.label}
            </li>
          );
        })}
      </ul>
      */}
      </div>)
      :
        (  <div className="bottom-half border-blue padding-column">
        <h5>{Constants.legendTitle}</h5>
        <ul className="bottom-list">
          {Constants.legendData.map((item, index) => {
            return (
              <li key={`legend  -- ${index}`}>
                <svg height="30" width="30">
                  <circle cx="15" cy="15" r="10" fill={item.color} />
                </svg>
                {item.label}
              </li>
            );
          })}
        </ul>
      </div>)}
    </div>
    </div>
  );
}
};

export default MainPage;
